import { BaseApi } from "../base.js";
import { API } from "../constants.js";

export class UserApi extends BaseApi {
  getReferralIncomesStatistic() {
    return this.request(
      () =>
        this.r.post(`${API.ENDPOINT}/v1/referral/cabinet/incomes/statistic`),
      (d) => this.user.setReferralIncomesStatistic(d),
    );
  }

  getDashboardOnboarding() {
    return this.request(
      (o) => this.r.get(`${API.ENDPOINT}/onboarding/status`, undefined, o),
      (d) => this.user.setDashboardOnboardingData(d),
      { disablePreloader: true },
      // () =>
      //   this.user.setDashboardOnboardingData({
      //     is_completed: false,
      //     completed_count: 2,
      //     total_count: 4,
      //     next_step: "two_factor",
      //     steps: [
      //       { code: "wallet_opened", order: 1, completed: true },
      //       { code: "verification", order: 2, completed: false },
      //       { code: "two_factor", order: 3, completed: true },
      //       { code: "top_up", order: 4, completed: false },
      //     ],
      //   }),
    );
  }

  async getAddress(coinId) {
    const { coins, setAddress } = this.coins;
    const coin = coins.value.find((c) => c.config.id === coinId);
    if (coin?.config.networks?.[0]?.address) return { ok: true };
    return this.request(
      () => this.r.post(`${API.ENDPOINT}/profile/address`, { coin_id: coinId }),
      (d) => setAddress(coinId, d),
    );
  }

  getCoinsSummary() {
    return this.r.get(`${API.ENDPOINT}/profile/coins_summary`);
  }

  getNoPay() {
    return this.r.get(`${API.EMCD_API}/settings/no-pay`);
  }

  get2faEnableMethod() {
    return this.r.get(`${API.ENDPOINT}/users/get-2fa-enable-method`);
  }

  getKycStatus() {
    return this.request(
      (o) => this.r.get(`${API.ENDPOINT}/kyc/status`, undefined, o),
      (d) => this.user.setKycStatus(d.kyc_status),
      { disablePreloader: true },
    );
  }
}
